import { Component, OnInit, OnChanges, AfterViewChecked, AfterViewInit, OnDestroy, SimpleChanges, Output, EventEmitter, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { IFilter, ICheckbox, IDropdownCustom, IOnboardingTour, OnboardingService } from 'codex-lib';
import { SortOrder } from 'src/app/enum/sort-order';
import { EnvelopeService } from '../../services/envelope.service';
import { EnvelopeFiltersService } from '../../services/envelope-filters.service';
import { EnvelopeSortOption } from '../../model/envelope-sort-option';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { EnvelopeOnBoardingService } from '../../services/envelope-on-boarding.service';
import { FeatureEnum } from 'src/app/enum/feature.enum';
import {
  closeDropdownForTour,
  createSortOrderTour,
  disableSortOrderTourLayer,
  enableSortOrderTourLayer,
  openDropdownForTour,
  setSortOrderTourPrevButtonAsBack,
  setSortOrderTourPrevButtonAsExit
} from '../../onboarding/onboarding-sort-order-tour';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-envelope-filter',
  templateUrl: './envelope-filter.component.html',
  styleUrls: ['./envelope-filter.component.scss']
})
export class EnvelopeFilterComponent implements OnInit, OnChanges, AfterViewInit, AfterViewChecked, OnDestroy {
  private readonly sortOnboardingId = 'sentSortOrderOnboarding';
  private readonly sortOnboardingSelector = '.sent-sort-order-onboarding';
  private readonly sortOnboardingMenuClass = 'envelope-sort-menu';
  private readonly sortOnboardingOptionsSelector = `.${this.sortOnboardingMenuClass}.show`;
  @ViewChild('sortDropdown', { static: false }) sortDropdown: any;
  @ViewChild('sortDropdown', { read: ElementRef, static: false })
  sortDropdownEl: ElementRef;

  @Input() searchValue: string = '';
  @Input() sortOptions: EnvelopeSortOption[] = [];
  @Input() sortOnboardingReady = true;
  @Input() set selectedSortOption(value: EnvelopeSortOption) {
    this._selectedSortOption = value;

    if (value) {
      this.sortOrder = value.sortOrder;
    }
  }

  get selectedSortOption(): EnvelopeSortOption {
    return this._selectedSortOption;
  }

  @Output() changeToGridModeClick = new EventEmitter();
  @Output() changeToListModeClick = new EventEmitter();
  @Output() checkAllClick = new EventEmitter();
  @Output() searchValueChange = new EventEmitter();
  @Output() sortOrderChange = new EventEmitter();
  @Output() sortChange = new EventEmitter<EnvelopeSortOption>();
  @Output() filterChange = new EventEmitter();
  @Output() filterClear = new EventEmitter();
  @Output() filterButtonClick = new EventEmitter<void>();

  filterOptions: IFilter | null = null;
  sortDropdownOptions: IDropdownCustom | null = null;
  showSortOnboarding = false;
  sortOnboarding: IOnboardingTour = createSortOrderTour(
    this.sortOnboardingSelector,
    'onboardings.sortOrder.sent.title',
    'onboardings.sortOrder.sent.description',
    this.sortOnboardingOptionsSelector,
    'onboardings.sortOrder.options.title',
    'onboardings.sortOrder.options.description'
  );

  checkboxOptions: ICheckbox = {
    span: '',
    checkboxSection: false,
  };

  sortOrder: SortOrder = SortOrder.Ascending;
  dateRange: any;
  timeOutId: any;
  private viewInitialized = false;
  private sortOnboardingRequested = false;
  private sortOnboardingOpened = false;
  private sortDropdownOpenedForTour = false;
  private removeSortTourNextClickListener: (() => void) | null = null;
  private _selectedSortOption: EnvelopeSortOption;
  private isClearingFilter = false;
  private clearFilterTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private envelopeFiltersService: EnvelopeFiltersService,
    private envelopeService: EnvelopeService,
    private renderer: Renderer2,
    private onboardingService: OnboardingService,
    private envelopeOnBoardingService: EnvelopeOnBoardingService,
    private googleAnalyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
   this.onboardingService.registerOnboarding(this.sortOnboardingId);

   if (!this.selectedSortOption) {
      this.sortOrder = SortOrder.Ascending;
    }

    try {
      const base = this.envelopeFiltersService.getFilterOptions?.();
      if (base) {
        this.filterOptions = this.sanitizeFilterOptions(base);
      }
    } catch (e) {
      console.warn('getFilterOptions() inicial falhou:', e);
      this.filterOptions = this.sanitizeFilterOptions({});
    }

    this.envelopeService.getFilters().subscribe((filterEnvelope) => {
      this.filterOptions =
        this.envelopeFiltersService.getFilterOptions(filterEnvelope);
    });

    this.buildSortDropdownOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const sortStateChanged = changes.sortOptions || changes.selectedSortOption;

    if (sortStateChanged) {
      this.buildSortDropdownOptions();
    }

    if (sortStateChanged || changes.sortOnboardingReady) {
      this.tryOpenSortOnboarding();
    }
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.tryOpenSortOnboarding();
  }

  ngAfterViewChecked(): void {
    const host: HTMLElement = this.sortDropdownEl?.nativeElement;
    const menu = host?.querySelector('.newDropdown:not(.envelope-sort-menu)');
    if (menu) {
      this.renderer.addClass(menu, 'envelope-sort-menu');
    }
  }

  ngOnDestroy(): void {
    this.removeSortTourNextClickListener?.();
    disableSortOrderTourLayer();
  }

  handleCloseSortOnboarding(): void {
    this.showSortOnboarding = false;
    closeDropdownForTour(this.sortDropdown);
    this.removeSortTourNextClickListener?.();
    this.removeSortTourNextClickListener = null;
    this.sortDropdownOpenedForTour = false;
    setSortOrderTourPrevButtonAsExit(this.sortOnboarding);
    disableSortOrderTourLayer();
    this.onboardingService.openOnboarding(false, this.sortOnboardingId);
    this.envelopeOnBoardingService
      .maskAsViewed(FeatureEnum.sentSortOrder)
      .pipe(take(1))
      .subscribe();
  }

  onfilter(value) {
    const filter = this.envelopeFiltersService.applyFilter(value);

    if (this.isClearingFilter) {
      this.clearPendingFilterClear();
      this.filterClear.emit(filter);
      return;
    }

    this.filterChange.emit(filter);
  }

  onClearFilter(emitChanges: boolean = true) {
    this.clearPendingFilterClear();

    if (emitChanges === false) {
      return;
    }

    this.isClearingFilter = true;
    this.clearFilterTimeoutId = setTimeout(() => this.clearPendingFilterClear(), 0);
  }

  onFilterClick(event: MouseEvent) {
    if (this.isFilterOpenButtonClick(event)) {
      this.filterButtonClick.emit();
    }
  }

  onCheckAllChange(value: boolean) {
    this.checkAllClick.emit(value);
  }

  onSearch(value: string) {
    this.searchValueChange.emit(value);
  }

  onSortClick() {
    this.toggleSort();
    this.sortOrderChange.emit(this.sortOrder);
  }

  onSortDropdownSelect(event: any) {
    const sortOption: EnvelopeSortOption = event?.properties?.sortOption;
    if (!sortOption) {
      return;
    }

    this.selectedSortOption = sortOption;
    this.sortChange.emit(sortOption);
    this.buildSortDropdownOptions();
  }

  private buildSortDropdownOptions(): void {
    if (!this.hasSortOptions()) {
      this.sortDropdownOptions = null;
      return;
    }

    const items = this.sortOptions.map((sortOption) => ({
      selected: this.isSortOptionSelected(sortOption),
      properties: {
        label: sortOption.label,
        sortOption,
      },
    }));

    this.sortDropdownOptions = {
      displayText: 'label',
      placement: 'bottom-right',
      listMaxHeight: 200,
      circleButton: {
        typeIcon: 'far',
        Icon: this.getSortOrderIcon(),
      },
      groups: [items],
    };

    this.sortDropdown?.forceOptionsUpdate?.(this.sortDropdownOptions);
  }

  private tryOpenSortOnboarding(): void {
    if (
      !this.viewInitialized ||
      !this.sortOnboardingReady ||
      this.sortOnboardingRequested ||
      this.sortOnboardingOpened ||
      !this.hasSortOptions()
    ) {
      return;
    }

    this.sortOnboardingRequested = true;
    setTimeout(() => {
      if (!document.querySelector(this.sortOnboardingSelector)) {
        this.sortOnboardingRequested = false;
        return;
      }

      this.envelopeOnBoardingService
        .verifyViewed(FeatureEnum.sentSortOrder)
        .pipe(take(1))
        .subscribe(
          (viewed: boolean) => {
            this.sortOnboardingRequested = false;

            if (viewed || !document.querySelector(this.sortOnboardingSelector)) {
              return;
            }

            this.sortOnboardingOpened = true;
            enableSortOrderTourLayer();
            this.showSortOnboardingTour();
          },
          () => {
            this.sortOnboardingRequested = false;
          }
        );
    });
  }

  private showSortOnboardingTour(): void {
    setSortOrderTourPrevButtonAsExit(this.sortOnboarding);
    this.showSortOnboarding = true;
    this.onboardingService.openOnboarding(true, this.sortOnboardingId);
    this.registerSortTourNextClickListener();
  }

  private registerSortTourNextClickListener(): void {
    if (this.removeSortTourNextClickListener) {
      return;
    }

    const handleNextClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target?.closest('.tour-actions .cdx-button--secondary')) {
        if (this.sortDropdownOpenedForTour) {
          closeDropdownForTour(this.sortDropdown);
          this.sortDropdownOpenedForTour = false;
          setSortOrderTourPrevButtonAsExit(this.sortOnboarding);
        }

        return;
      }

      if (!target?.closest('#tour-next') || this.sortDropdownOpenedForTour) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      this.sortDropdownOpenedForTour = true;
      setSortOrderTourPrevButtonAsBack(this.sortOnboarding);
      this.openSortDropdownAndAdvanceTour();
    };

    document.addEventListener('click', handleNextClick, true);
    this.removeSortTourNextClickListener = () => document.removeEventListener('click', handleNextClick, true);
  }

  private openSortDropdownAndAdvanceTour(attempt = 0): void {
    const opened = openDropdownForTour(
      this.sortDropdown,
      this.sortDropdownEl?.nativeElement,
      this.sortOnboardingMenuClass
    );

    if (opened || attempt >= 5) {
      setTimeout(() => document.getElementById('tour-next')?.click(), 50);
      return;
    }

    setTimeout(() => this.openSortDropdownAndAdvanceTour(attempt + 1), 100);
  }

  toggleSort() {
    if (this.sortOrder === SortOrder.Ascending) {
      this.sortOrder = SortOrder.Descending;
    } else {
      this.sortOrder = SortOrder.Ascending;
    }
  }

  onGridModeClick() {
    this.trackAnalyticsEvent('Signer_Enviado_Grid');
    this.changeToGridModeClick.emit();
  }

  onListModeClick() {
    this.trackAnalyticsEvent('Signer_Enviado_Lista');
    this.changeToListModeClick.emit();
  }

  getSortOrderIcon() {
    return this.sortOrder === SortOrder.Ascending
      ? 'sort-amount-down'
      : 'sort-amount-up';
  }

  hasSortOptions(): boolean {
    return this.sortOptions && this.sortOptions.length > 0;
  }

  isSortOptionSelected(sortOption: EnvelopeSortOption): boolean {
    return (
      !!this.selectedSortOption &&
      this.selectedSortOption.sortField === sortOption.sortField &&
      this.selectedSortOption.sortOrder === sortOption.sortOrder
    );
  }

  private sanitizeFilterOptions<T = any>(obj: T): T {
    const ARRAY_LIKE_KEYS =
      /^(items|options|values|list|groups|children|entries|elements|data|sources)$/i;
    const walk = (val: any): any => {
      if (Array.isArray(val)) return val.map(walk);
      if (val && typeof val === 'object') {
        const out: any = {};
        for (const k of Object.keys(val)) {
          const v = (val as any)[k];
          if (v === undefined || v === null) {
            // se o nome da chave indica array, vira [], senão mantém null/'' seguro
            out[k] = ARRAY_LIKE_KEYS.test(k)
              ? []
              : typeof v === 'string'
              ? ''
              : v;
          } else if (typeof v === 'object') {
            out[k] = walk(v);
          } else {
            out[k] = v;
          }
        }
        return out;
      }

      if (val === null || val === undefined) return '';
      return val;
    };

    return walk(obj);
  }

  private trackAnalyticsEvent(action: string): void {
    this.googleAnalyticsService.sendEvent(
      new TrackerData(AnalyticEventClient.TK_PT_SIGNER_SENT, action)
    );
  }

  private isFilterOpenButtonClick(event: MouseEvent): boolean {
    const target = event.target as Element | null;
    const filterButton = target?.closest('button.cdx-btn__rounded');

    return !!filterButton &&
      !filterButton.classList.contains('disabled') &&
      !filterButton.closest('.cdx-btn__group__drop-chips');
  }

  private clearPendingFilterClear(): void {
    this.isClearingFilter = false;

    if (this.clearFilterTimeoutId === null) {
      return;
    }

    clearTimeout(this.clearFilterTimeoutId);
    this.clearFilterTimeoutId = null;
  }
}
